import styled from "@emotion/styled";

export const StyledButtonLabel = styled("span")({
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%",
    textAlign: "left",
});
